import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationBg from "./locales/bg/translation.json";
import translationENG from "./locales/en/translation.json";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  bg: {
    translation: translationBg,
  },
  en: {
    translation: translationENG,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "en", // use en if detected lng is not available
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });
export default i18n;
